import React from 'react';
import { 
    Box, 
    Typography,
    Card,
    CardContent
} from '@mui/material';
import ImageIcon from '@mui/icons-material/Image';
import InfoIcon from '@mui/icons-material/Info';
import ImageGallery from '../../../../components/Settings/ImageGallery';

// Section Card Component
const SettingsSection = ({ title, icon: Icon, children }) => {
    return (
        <Card 
            elevation={0}
            sx={{ 
                mb: { xs: 2, sm: 3 },
                borderRadius: 2,
                border: '1px solid',
                borderColor: 'divider',
                overflow: 'hidden'
            }}
        >
            <Box 
                sx={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: 1.5,
                    px: { xs: 2, sm: 2.5 },
                    py: { xs: 1.25, sm: 1.5 },
                    bgcolor: 'grey.50',
                    borderBottom: '1px solid',
                    borderColor: 'divider'
                }}
            >
                {Icon && <Icon sx={{ fontSize: { xs: 18, sm: 20 }, color: 'primary.main' }} />}
                <Typography 
                    variant="subtitle2" 
                    sx={{ 
                        fontWeight: 600,
                        color: 'text.primary',
                        fontSize: { xs: '0.875rem', sm: '0.9rem' }
                    }}
                >
                    {title}
                </Typography>
            </Box>
            <CardContent sx={{ 
                px: { xs: 2, sm: 2.5 },
                py: { xs: 2, sm: 2 },
                '&:last-child': { pb: { xs: 2, sm: 2 } }
            }}>
                {children}
            </CardContent>
        </Card>
    );
};

const CustomImagesTab = ({ globalTenantId }) => {
    return (
        <Box sx={{ maxWidth: 1200, mx: 'auto' }}>
            {/* Info Section */}
            <SettingsSection title="About Custom Images" icon={InfoIcon}>
                <Typography 
                    variant="body2" 
                    sx={{ 
                        color: 'text.secondary',
                        fontSize: { xs: '0.875rem', sm: '0.9rem' },
                        lineHeight: 1.6
                    }}
                >
                    Upload images to use in your Custom Theme or Custom UI. Click on an image to reveal its public URL 
                    (shown below the gallery) which you can copy and reference in your Custom Theme CSS or Custom UI HTML.
                </Typography>
            </SettingsSection>

            {/* Image Gallery Section */}
            <SettingsSection title="Image Gallery" icon={ImageIcon}>
                <ImageGallery tenantId={globalTenantId} />
            </SettingsSection>
        </Box>
    );
};

export default CustomImagesTab;
